"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromEnglish = fromEnglish;
exports.toEnglish = toEnglish;
var _i18n = _interopRequireDefault(require("../localization/i18n"));
var _sbVerbiage = _interopRequireDefault(require("@simplybenefits/sb-verbiage"));
var map = _sbVerbiage["default"].translations.map;

/**
 * Convert english to french for data coming from the server
 * @param type
 * @param key
 * @returns {*}
 */
function fromEnglish(type, key) {
  if (_i18n["default"].locale === "en") {
    return key;
  }
  if (map[type] && map[type].fr && map[type].fr[key]) {
    return map[type].fr[key]; // Return the French translation if available
  }

  // otherwise return whatever we can for this translation
  return key || type;
}

/**
 * Convert french to english to be sent to backend
 * @param type
 * @param key
 * @returns {*}
 */
function toEnglish(type, key) {
  if (_i18n["default"].locale === "en") {
    return key;
  }
  if (map[type] && map[type].en && map[type].en[key]) {
    return map[type].en[key]; // Return the English translation if available
  }

  // Otherwise return whatever we can for this translation
  return key || type;
}